import { render } from "./NumericResponses.vue?vue&type=template&id=7ccb2768&scoped=true"
import script from "./NumericResponses.vue?vue&type=script&lang=js"
export * from "./NumericResponses.vue?vue&type=script&lang=js"

import "./NumericResponses.vue?vue&type=style&index=0&id=7ccb2768&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccb2768"]])

export default __exports__